/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-03-25T16:40:15.465
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listReportFinancialPaymentPostpone,
	listReportFinancialPaymentPostponeInit,
	listReportFinancialPaymentPostponeByAuthorizations,
	deleteReportFinancialPaymentPostpone
	
} from '@api/report/ReportFinancialPaymentPostpone';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listReportFinancialPaymentPostpone({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportFinancialPaymentPostpone(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportFinancialPaymentPostponeByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportFinancialPaymentPostponeByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportFinancialPaymentPostponeInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportFinancialPaymentPostponeInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteReportFinancialPaymentPostpone({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteReportFinancialPaymentPostpone({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
